import { nsTerminal } from '@/app/i18n/namespaces';

const AUTHORIZATION_CODE_RESULT = {
    AUTHORIZED: { name: 'AUTHORIZED', entity: 'authorization_code_result.AUTHORIZED', namespace: nsTerminal, variant: 'green' },
    NOT_VERIFIED: { name: 'NOT_VERIFIED', entity: 'authorization_code_result.NOT_VERIFIED', namespace: nsTerminal, variant: 'orange' },
    REFUSED: { name: 'REFUSED', entity: 'authorization_code_result.REFUSED', namespace: nsTerminal, variant: 'red' },
    PENDING: { name: 'PENDING', entity: 'authorization_code_result.PENDING', namespace: nsTerminal, variant: 'orange' },
    EXPIRED: { name: 'EXPIRED', entity: 'authorization_code_result.EXPIRED', namespace: nsTerminal, variant: 'red' },
    CANCELLED: { name: 'CANCELLED', entity: 'authorization_code_result.CANCELLED', namespace: nsTerminal, variant: 'red' }
};

export default AUTHORIZATION_CODE_RESULT;